<template>
  <div class="home">
  
    <Reproductor msg="Los numeros" audio2="../mp3/PrimariaA/04PA.mp3" cover="../img/1.jpg" name="Primaria A - Lección #4"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA4',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
